import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidKlankvoetenRecognize } from '../../../../mechanics/rid-klankvoeten-recognize/rid-klankvoeten-recognize';

@Component({
  selector: 'app-klankvoeten-recognize-page',
  imports: [RidKlankvoetenRecognize],
  templateUrl: './klankvoeten-recognize-page.html',
})
export class KlankvoetenRecognizePage {
  protected readonly router = inject(Router);
}
